import AddIcon from '@mui/icons-material/Add'
import { Box, Divider, List, ListItem, ListItemText, Paper, Typography } from "@mui/material"
import { DataGrid, GridColDef, GridColumnVisibilityModel, GridFilterModel, GridSortModel } from '@mui/x-data-grid'
import { useSnackbar } from 'notistack'
import { FC, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { FloorMaterialPropsType, FloorMaterialType, MaterialType, UserType } from '../../../api/appAPI'
import { actions as appActions, addFloorMaterial, editFloorMaterial } from "../../../redux/appReducer"
import { StateType } from '../../../redux/store'
import DefineFloorMaterial from './DefineFloorMaterial'
import EditFloorMaterial from './EditFloorMaterial'
import { EnqueueSnackbarType } from '../../../components/common/Helpers'
import { saveGridStateInLocalStorage } from '../../../common/helpers'
import { AvailableMaterialsForFM } from '../../../redux/itemReducer'

interface IProps {
    user: UserType

    materials: AvailableMaterialsForFM
    floorMaterials: FloorMaterialType[]
    fmGridVisibilityModel: GridColumnVisibilityModel | undefined
    fmGridSortModel: GridSortModel | undefined
    fmGridFilterModel: GridFilterModel | undefined

    setFMGridVisibilityModel(model: GridColumnVisibilityModel | undefined): void
    setFMGridSortModel(model: GridSortModel | undefined): void
    setFMGridFilterModel(model: GridFilterModel | undefined): void
    addFloorMaterial(fmProps: FloorMaterialPropsType, enqueueSnackbar: EnqueueSnackbarType): void
    editFloorMaterial(id: number, fmProps: FloorMaterialPropsType, enqueueSnackbar: EnqueueSnackbarType): void

}

const FloorMaterialsTab: FC<IProps> = props => {
    const [activeFMId, setActiveFMId] = useState(0)
    const [activeFM, setActiveFM] = useState<undefined | FloorMaterialType>(props.floorMaterials.find(m => m.id === activeFMId))

    const { enqueueSnackbar } = useSnackbar()


    useEffect(() => {
        setActiveFM(props.floorMaterials.find(m => m.id === activeFMId))
    }, [activeFMId])

    useEffect(() => {
        saveGridStateInLocalStorage({ visibilityModel: props.fmGridVisibilityModel, sortModel: props.fmGridSortModel, filterModel: props.fmGridFilterModel }, 'floorMaterial')
    }, [props.fmGridVisibilityModel, props.fmGridSortModel, props.fmGridFilterModel])


    return (
        <Box
            display='flex'
            style={{ height: window.innerHeight - 48 }}
        >
            <Box
                display='flex'
                flexDirection='column'
                alignItems='center'
                pt={2}
                style={{ borderRight: 'solid 1px black', width: '50%' }}
            >
                <Typography variant='h6'>Floor Materials List</Typography>

                <Paper style={{ width: '90%', maxHeight: '90%', overflowY: 'auto' }}>
                    <List component="nav" style={{ padding: 0 }}>
                        <ListItem button onClick={() => { setActiveFMId(0) }}>
                            <ListItemText primary='New Floor Material' />
                            <AddIcon />
                        </ListItem>
                        <Divider />
                    </List>

                </Paper>
                <DataGrid
                    style={{ width: '90%', maxHeight: '90%', overflowY: 'auto' }}

                    columns={(() => {
                        const columns = [
                            { field: 'id', },
                            { field: 'date', headerName: 'Last Modified', type: 'datetime', minWidth: 160 },
                            { field: 'name', headerName: 'Name', minWidth: 200 },
                            { field: 'sku', headerName: 'Product SKU', width: 200, },
                            { field: 'shortDescription', headerName: 'Description', width: 200, },
                            { field: 'floorSetupCharge', headerName: 'Floor Setup Charge', type: "number", width: 200, },
                            { field: 'floorPricePerSqFt', headerName: 'Floor Price Per Sq. Ft', type: "number", width: 200, },
                            { field: 'curbSetupCharge', headerName: 'Curb Setup Charge', type: "number", width: 200, },
                            { field: 'curbPricePerSqFt', headerName: 'Curb Price Per Sq. Ft', type: "number", width: 200, },
                            { field: 'curbLinearPricePerFt', headerName: 'Curb Lineal Price Per Ft', type: "number", width: 200, },
                            // {
                            //     field: 'actions',
                            //     headerName: 'Actions',
                            //     filterable: false,
                            //     sortable: false,
                            //     renderCell: (params: GridCellParams) => <Box onClick={(e) => {
                            //         e.stopPropagation() // don't select this row after clicking 
                            //     }}>
                            //         <IconButton edge="end" onClick={() => { handleCopyMaterialGroupClick(parseInt(params.id.toString())) }}>
                            //             <CopyIcon />
                            //         </IconButton>
                            //         {![9, 10].includes(parseInt(params.id.toString())) &&
                            //             <IconButton edge="end" onClick={() => { handleDeleteMaterialClick(parseInt(params.id.toString())) }}>
                            //                 <DeleteIcon />
                            //             </IconButton>
                            //         }
                            //     </Box>,
                            //     width: 150,
                            // },
                        ]
                        if (props.user && props.user.role === 'admin') {
                            columns.splice(1, 0, { field: 'dealerId', headerName: 'Dealers IDs', width: 150 })
                        }
                        return columns
                    })() as GridColDef[]}

                    // hideFooterPagination
                    rows={props.floorMaterials.map(fm => ({
                        id: fm.id,
                        date: new Date(fm.date),
                        name: fm.name,
                        sku: fm.sku,
                        dealerId: fm.dealerId,
                        floorSetupCharge: fm.floorSetupCharge,
                        floorPricePerSqFt: fm.floorPricePerSqFt,
                        curbSetupCharge: fm.curbSetupCharge,
                        curbPricePerSqFt: fm.curbPricePerSqFt,
                        curbLinearPricePerFt: fm.curbLinearPricePerFt,
                        shortDescription: fm.shortDescription,
                        // longDescription:fm.longDescription, 
                        // pictureUrl:fm.pictureUrl, 
                        // pdfUrl:fm.pdfUrl
                    }))}
                    onRowClick={(param) => {
                        setActiveFMId(parseInt(param.id.toString()))
                    }}

                    columnVisibilityModel={props.fmGridVisibilityModel}
                    onColumnVisibilityModelChange={(model) => {
                        props.setFMGridVisibilityModel({ ...model })
                    }}

                    sortModel={props.fmGridSortModel}
                    onSortModelChange={(model) => {
                        if (JSON.stringify(model) !== JSON.stringify(props.fmGridSortModel))
                            props.setFMGridSortModel(model)
                    }}

                    filterModel={props.fmGridFilterModel}
                    onFilterModelChange={(model) => {
                        if (JSON.stringify(model) !== JSON.stringify(props.fmGridFilterModel))
                            props.setFMGridFilterModel(model)
                    }}

                    showCellVerticalBorder

                    rowSelectionModel={activeFMId}
                />
            </Box>
            {activeFM === undefined
                ? <DefineFloorMaterial materials={props.materials} addFloorMaterial={props.addFloorMaterial} />
                : <EditFloorMaterial fm={activeFM} materials={props.materials} editFloorMaterial={props.editFloorMaterial} />
            }
        </Box>
    )
}

const mapStateToProps = (state: StateType) => ({
    materials: state.itemReducer.availableMaterialsForFM,
    floorMaterials: state.appReducer.floorMaterialsList,
    fmGridVisibilityModel: state.appReducer.floorMaterialGrid.visibilityModel,
    fmGridSortModel: state.appReducer.floorMaterialGrid.sortModel,
    fmGridFilterModel: state.appReducer.floorMaterialGrid.filterModel,
})

export default connect(mapStateToProps, {
    addFloorMaterial,
    editFloorMaterial,
    setFMGridVisibilityModel: appActions.setFloorMaterialGridVisibilityModel,
    setFMGridSortModel: appActions.setFloorMaterialGridSortModel,
    setFMGridFilterModel: appActions.setFloorMaterialGridFilterModel,
})(FloorMaterialsTab)